const routes = [
	// 工作台
  {
    path: "/home",
    name: "indexPage",
		meta: {
			title: '工作台',
			hasBack: false
		},
    component: () => import("../pages/indexPage/index.vue")
  },
  // 全局搜索查看更多
  {
    path: '/showAllSearch',
    name: 'ShowAllSearch',
    meta: {
      title: '全局搜索',
      hasBack: false
    },
    component: () => import('../pages/menu/globalSearch/showAllSearch.vue'),
  },
  // 全局搜索管理功能+帮助中心（内部账号使用）
  {
    path: '/manageFunction',
    name: 'manageFunction',
    meta: {
      title: '全局搜索',
      hasBack: false
    },
    component: () => import('../pages/menu/globalSearch/manage/manageFunction.vue'),
  },
];

export default routes;
